import { RootState } from "domain/store";

export const selectFavoriteTechniques = (state: RootState) => {
  return state.activities.favoriteTechniques;
};

export const selectFavoriteSeances = (state: RootState) => {
  return state.activities.favoriteSeances;
};

export const selectFavoriteTutorials = (state: RootState) => {
  return state.activities.favoriteTutorials;
};

export const selectFavoriteVisualSupports = (state: RootState) => {
  return state.activities.favoriteVisualSupports;
};

export const selectIsActivitiesLoading = (state: RootState) => {
  return state.activities.isActivitiesLoading;
};

export const selectPremiumActivitiesCount = (state: RootState) => {
  return state.activities.premiumActivitiesCount;
};
